import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, AfterViewInit, HostListener, DebugElement, OnDestroy } from '@angular/core';
import { Adm000Service } from '../../../../../core/_base/_service/adm000.service';
import { Router, NavigationEnd } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';

import { MenuAsideService } from '../../../../../core/_base/layout/services/menu-aside.service';
import { Console } from 'console';
import { ADM0008Class } from '../../../../../Class/ADM0008/adm0008-class';
import { ADM0008ServiceService } from '../../../../../Service/ADM0008/adm0008-service.service';
import { Subscription } from 'rxjs';
import { MenuserviceService } from '../../../../../Service/menuservice/menuservice.service';

@Component({
  selector: 'kt-side-nav-widget',
  templateUrl: './side-nav-widget.component.html',
  styleUrls: ['./side-nav-widget.component.scss'],
  animations: [
    trigger('slideAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(-20px)', opacity: 0 }),
        animate('150ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ transform: 'translateX(-20px)', opacity: 0 }))
      ])
    ])
  ]
})
export class SideNavWidgetComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('sideNavRoot', { static: true }) sideNavRoot!: ElementRef;

  bottomDivHeight: any;
  ArrModule: any[] = [];
  activatedId: any;
  MyTasks: any;
  MyApprovals: any;
  MyTasksCaption: any;
  MyApprovalsCaption: any;

  PageName:string;

  menuOpen = false; // track menu open/close
  menuItems: any[]  = [];
  selectedModuleId: number | null = null;
  moduleMenuActive = false;
  urlPath: string = '';
  urlHome: string = '';

  showContextMenu = false;
  menuX = 0;
  menuY = 0;

  // store previous overflow settings so we can restore when leaving this view
  private previousBodyOverflow = '';
  private previousHtmlOverflow = '';
  private hasNoScrollClass = false;

  // track expanded/collapsed state for each parent menu in otherMenu
  expandedStates: { [key: number]: boolean } = {};

  private unsubscribe: Subscription[] = [];

  TopMenus: any[] = [];

  constructor(
    private objAdm000Service: Adm000Service,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private elRef: ElementRef,
    public menuAsideService: MenuAsideService,
    private ADM0008service:ADM0008ServiceService,
     private menuservice:MenuserviceService
  ) { }

  ngOnInit() {

  

//widget/widget-dashboard/3
    // hide browser scrollbar on this dashboard view
    // this.previousBodyOverflow = document.body.style.overflow;
    // this.previousHtmlOverflow = document.documentElement.style.overflow;
    // document.body.style.overflow = 'hidden';
    // document.documentElement.style.overflow = 'hidden';

    // add helper class to body/html in case other CSS forces overflow
    // document.body.classList.add('no-vertical-scroll');
    // document.documentElement.classList.add('no-vertical-scroll');
    // this.hasNoScrollClass = true;

    this.urlPath = this.router.url;

    if (this.urlPath.startsWith('/dashboard')) {
      // this.menuOpen = true;
      this.changeDetectorRef.detectChanges();
    }

    if(this.router.url.toLocaleLowerCase().includes("widget/widget-dashboard") || this.router.url.toLocaleLowerCase().includes("widget/landing")) {
      
    this.urlHome = "Y";
    this.moduleMenuActive=false;
    // Auto-open menu on home pages for first load
    // this.menuOpen = true;
    }
    else {
      this.urlHome = "N";
    }

    console.log('ngOnInit - Current URL:', this.router.url, '| urlHome:', this.urlHome, '| menuOpen:', this.menuOpen);

       this.LoadMenudata();
           return;

    // if(this.router.url == "/widget/landing" || this.router.url == "/widget/widget-dashboard/1" || this.router.url == "/widget/widget-dashboard/2" || this.router.url == "/widget/widget-dashboard/3" || this.router.url == "/widget/widget-dashboard/4")
    // {
    //   this.urlHome = "Y";
    // }
    // else
    // {
    //   this.urlHome = "N";
    // }   

    console.log('Current URL:', this.router.url, '| urlHome:', this.urlHome);

    const subscr = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.urlPath = event.url;
        if (this.urlPath.startsWith('/dashboard')) {
          // this.menuOpen = true;
          this.changeDetectorRef.detectChanges();
        }
      }
    });
    this.unsubscribe.push(subscr);   

    const selectedModuleSub = this.menuAsideService.selectedModuleId$.subscribe(id => {
      this.selectedModuleId = id;
      // alert(id)
      if (this.isCurrentWidgetDashboard3()) {
        // this.menuOpen = false;
        this.moduleMenuActive = false;
        this.changeDetectorRef.detectChanges();
        return;
      }





        // this.menuOpen = true;
        this.moduleMenuActive = true;
        this.menuAsideService.loadMenuULMenu().subscribe(data => {
          this.menuItems = data;
          this.changeDetectorRef.detectChanges();
        });
   
      
        this.moduleMenuActive = false;
      
    });
    this.unsubscribe.push(selectedModuleSub);

    if(this.urlHome == "Y")
    {
      this.objAdm000Service.GetModules().subscribe(dataAdm0000 => {
        const data = dataAdm0000.objADM0001;
        this.ArrModule = data;
        this.activatedId = this.GetModules();

        this.MyApprovals = this.ArrModule.filter(x => x.PageName == "usr0070");
        if (this.MyApprovals && this.MyApprovals.length)
          this.MyApprovalsCaption = this.MyApprovals[0].MenuDisplayName;

        this.changeDetectorRef.detectChanges();
      });
    }
    else
    {
       this.menuAsideService.loadMenuULMenu().subscribe(data=>{
        this.menuItems = data;
        this.changeDetectorRef.detectChanges();
       });
    }

         
  }

LoadMenudata()
{
  console.log('LoadMenudata started - urlHome:', this.urlHome);
  
  if( localStorage.getItem('menudata')==null)
  {
    console.log('No localStorage data, calling API...');
    this.objAdm000Service.GetModules().subscribe(
      dataAdm0000 => {
        console.log('API Response received:', dataAdm0000);
        if(dataAdm0000.userMenus && dataAdm0000.userMenus.length > 0) {
          this.menuservice.setMenu(dataAdm0000.userMenus);
          this.LoadSubmenu(dataAdm0000.userMenus);
          console.log('TopMenus loaded from API:', this.TopMenus);
          console.log('urlHome:', this.urlHome, 'moduleMenuActive:', this.moduleMenuActive);
        } else {
          console.warn('API returned no userMenus data');
        }
        this.changeDetectorRef.detectChanges();
      },
      error => {
        console.error('Error loading menu data from API:', error);
        this.changeDetectorRef.detectChanges();
      }
    );
  }
  else
  {
    console.log('Loading from localStorage...');
    let menudata = JSON.parse(localStorage.getItem('menudata') || '[]');
    console.log('localStorage menudata:', menudata);
    
   this.LoadSubmenu(menudata);
    console.log('TopMenus loaded from localStorage:', this.TopMenus);
    console.log('urlHome:', this.urlHome, 'moduleMenuActive:', this.moduleMenuActive);
    this.changeDetectorRef.detectChanges();
  }
}

LoadSubmenu(menudata:any)
{
  console.log('LoadSubmenu called - urlHome:', this.urlHome, 'menudata:', menudata);
  
  if(this.urlHome == "N")
  {
    this.moduleMenuActive = true;
   // let menudata = JSON.parse(localStorage.getItem('menudata') || '[]');
    let getmenudata = this.getSubMenus(menudata,Number( this.menuAsideService.getSelectedModuleId())); 
    this.menuItems = getmenudata;
    console.log('menuItems set for submenu:', this.menuItems);
    //let data=getmenudata;
    // replace someMenuId with the actual menu ID you want to get submenus for
  }
  else
  {
     this.TopMenus =menudata.map(menu => ({
          MenuID: menu.menuid,
          IconTag: menu.icon,
          MenuOrderNo: Number(menu.MenuOrderNo),
          MenuDisplayName: menu.title
           }));
    this.moduleMenuActive = false;
    console.log('TopMenus set in LoadSubmenu:', this.TopMenus);
    console.log('TopMenus length:', this.TopMenus.length);
  }
  
  // Force change detection
  this.changeDetectorRef.detectChanges();

}



 getSubMenus(menus: any[], menuId: number): any[] {
  for (const menu of menus) {
    if (menu.menuid === menuId) {
      return menu.submenu || [];
    }

    const result = this.getSubMenus(menu.submenu || [], menuId);
    if (result.length) {
      return result;
    }
  }

  return [];
}

  // Sort submenu items by MenuOrderNo in ascending order
  getSortedSubmenu(submenu: any[]): any[] {
    if (!submenu || submenu.length === 0) {
      return [];
    }
    return submenu.sort((a, b) => {
      const orderA = Number(a.MenuOrderNo) || 0;
      const orderB = Number(b.MenuOrderNo) || 0;
      return orderA - orderB;
    });
  }

  GetModules() {
    return this.ArrModule.filter(x => x.IsModule == 1);
  }

  private isCurrentWidgetDashboard3(): boolean {
    return this.router.url.includes('/widget/widget-dashboard/');
  }

  // Toggle menu (stopPropagation from template)
  toggleMenu(event?: MouseEvent) {
   
    if (event) { event.stopPropagation(); } // prevent document click from closing immediately
    if (this.menuOpen) {
      this.menuOpen = false;
      if (this.moduleMenuActive) {
        this.moduleMenuActive = false;
        this.menuAsideService.setSelectedModuleId(null);
      }
    } else {
      this.menuOpen = true;
      console.log('Menu opened - urlHome:', this.urlHome, 'moduleMenuActive:', this.moduleMenuActive);
    }
  }

  // Called when any menu item is clicked - close the menu
onMenuItemClick(sub: any) {

  this.menuOpen = false;

  if (this.moduleMenuActive) {
    this.moduleMenuActive = false;
    this.menuAsideService.setSelectedModuleId(null);
  }

  if (sub && sub.page) {

    let pagePath = sub.page;

    if (!pagePath.startsWith('/')) {
      pagePath = '/' + pagePath;
    }

    const tabTitle = encodeURIComponent(sub.title || '');

    const separator = pagePath.includes('?') ? '&' : '?';

    this.router.navigateByUrl(
      `${pagePath}${separator}tabTitle=${tabTitle}`
    );
  }
}

onModuleClick(moduleId: number) {
  this.menuAsideService.setSelectedModuleId(moduleId);

}

  // menu actions should also close the menu
  showMytasks() {
    this.menuOpen = false;
    this.router.navigate(['/hrms/tsk0120-update-find']);
  }

  onApprovalsClick() {
    this.menuOpen = false;
    this.router.navigate(['/hrms/usr0070-summary']);
  }

  // Close menu when clicking outside component
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.elRef.nativeElement.contains(event.target);
    if (!clickedInside && this.menuOpen) {
      this.menuOpen = false;
      if (this.moduleMenuActive) {
        this.moduleMenuActive = false;
        this.menuAsideService.setSelectedModuleId(null);
      }
    }
  }

  // Toggle a parent menu group (expand/collapse)
  toggleGroup(index: number) {
    this.expandedStates[index] = !this.expandedStates[index];
  }

  ngAfterViewInit() {
    // optional leftover logic
  }

  ngOnDestroy(): void {
    // restore default scrolling when leaving this view
    document.body.style.overflow = this.previousBodyOverflow || '';
    document.documentElement.style.overflow = this.previousHtmlOverflow || '';

    if (this.hasNoScrollClass) {
      document.body.classList.remove('no-vertical-scroll');
      document.documentElement.classList.remove('no-vertical-scroll');
    }

    this.unsubscribe.forEach(sb => sb.unsubscribe());
  }




  RightClickUrl: string = '';

  readonly CONTEXT_MENU_HEIGHT = 90; // adjust if menu grows

  onRightClick(event: MouseEvent, sub: any) {

    this.RightClickUrl = sub.page;
    this.PageName = sub.title;

    event.preventDefault();
    event.stopPropagation();

    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();

    // X aligns with LI
    // this.menuX = rect.left + rect.width / 2;
    this.menuX = rect.left + rect.width;

    // Y opens ABOVE the LI
    // this.menuY = rect.top - this.CONTEXT_MENU_HEIGHT;
    this.menuY = rect.top;

    // Prevent menu going outside viewport
    if (this.menuY < 10) {
      this.menuY = rect.bottom + 5;
    }

    this.showContextMenu = true;
  }

  @HostListener('document:click')
  closeContextMenu() {
    this.showContextMenu = false;
  }

openInNewWindow(item?: any) {

  let url = '/#' + this.RightClickUrl;



    const separator = this.RightClickUrl.includes('?') ? '&' : '?';

    url += `${separator}tabTitle=${encodeURIComponent(this.PageName)}`;
  

  window.open(url, '_blank');

  this.showContextMenu = false;
}

  addToFavorite(item: any){
      var classobj=new ADM0008Class();
  
      classobj.PageUrl=this.RightClickUrl;
      this.ADM0008service.Create(classobj).subscribe(data=>{
  
        if(data.IsSuccess)
        {

        }
        else{
          if(data.ErrorCodes == "Duplication")
          {
          }
          else
          {
          }
        }
      
        })
    
      console.log(item);
    }
}
